import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { submitSurvey } from "../../../redux/actions/auth/survey";
import { changeModalState } from "../../../redux/actions/modal/modal";
import "./AmpSurvey.css";

export function AmpSurveyTitle(): JSX.Element {
    const { t } = useTranslation("login");
    return <div className="survey-title">
        {t("survey-header")}
    </div>
}

export default function AmpSurvey(): JSX.Element {
    const { t } = useTranslation("login");
    const dispatch = useDispatch();
    const id = localStorage.getItem("surveyId");

    const takeSurvey = () => {
        dispatch(submitSurvey(id as string, "Y"));
        window.open(t("survey-link"), '_blank').focus();
        dispatch(changeModalState("modal-fade-out"));
        localStorage.clear();
    }

    const noSurvey = () => {
        dispatch(submitSurvey(id as string, "N"));
        dispatch(changeModalState("modal-fade-out"));
        localStorage.clear();
    }


    return (
    <div className="survey-wrapper">
        <div className="survey-top">
            <h2>{t("survey-header-2")}</h2>
            <p>{t("survey-p-1")}</p>
            <p>{t("survey-p-2")}</p>
            <div className="survey-button-wrapper"><button className="survey-button" onClick={() => {takeSurvey()}}>{t("survey-take")}</button></div>
            <div className="survey-button-wrapper"><button className="survey-button" onClick={() => {noSurvey()}}>{t("survey-no")}</button></div>
        </div>
    </div>

    )
}